export const conversionFactorsO = {
  "sq. ft.": {
    "sq. ft.": 1,
    "sq. yards": 0.111111,
    "sq. m.": 0.092903,
    acres: 0.000023,
    hectares: 0.000009,
    bigha: 0.000092,
    marla: 0.003673,
    kanal: 0.000184,
  },
  "sq. yards": {
    "sq. ft.": 9,
    "sq. yards": 1,
    "sq. m.": 0.836127,
    acres: 0.000207,
    hectares: 0.000084,
    bigha: 0.000826,
    marla: 0.033058,
    kanal: 0.001653,
  },
  "sq. m.": {
    "sq. ft.": 10.763915,
    "sq. yards": 1.19599,
    "sq. m.": 1,
    acres: 0.000247,
    hectares: 0.0001,
    bigha: 0.000988,
    marla: 0.039537,
    kanal: 0.001977,
  },
  acres: {
    "sq. ft.": 43560.057264,
    "sq. yards": 4840.006363,
    "sq. m.": 4046.86,
    acres: 1,
    hectares: 0.404686,
    bigha: 4.000005,
    marla: 160.00021,
    kanal: 8.000011,
  },
  hectares: {
    "sq. ft.": 107639.150512,
    "sq. yards": 11959.905612,
    "sq. m.": 10000.0,
    acres: 2.471052,
    hectares: 1,
    bigha: 9.88422,
    marla: 395.368781,
    kanal: 19.768439,
  },
  bigha: {
    "sq. ft.": 10890.0,
    "sq. yards": 1210.0,
    "sq. m.": 1011.71367,
    acres: 0.25,
    hectares: 0.101171,
    bigha: 1,
    marla: 40.0,
    kanal: 2.0,
  },
  marla: {
    "sq. ft.": 272.25,
    "sq. yards": 30.25,
    "sq. m.": 25.292842,
    acres: 0.002529,
    hectares: 0.000009,
    bigha: 0.025,
    marla: 1,
    kanal: 0.05,
  },
  kanal: {
    "sq. ft.": 5445.0,
    "sq. yards": 605.0,
    "sq. m.": 505.856835,
    acres: 0.125,
    hectares: 0.050586,
    bigha: 0.5,
    marla: 20.0,
    kanal: 1,
  },
};
export const conversionFactors = () => {
  return Object.keys(conversionFactorsO).map((value) => ({
    key: value,
    text: value,
    value: value,
    style: { fontSize: "18px" },
  }));
};
